import { RelativeSpinner } from '@components/spinners/Spinner/RelativeSpinner';

export function Spinner(props: any) {
  return (
    <div className="relative h-32 inset-0 flex items-center justify-center" {...props}>
      <RelativeSpinner />
    </div>
  );
}
